import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Input,
  Dropdown,
  TextArea,
  Checkbox,
  FormGroup,
  FormField
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardTreatmentOrderUX = (props: any) => {
    return(
      <div>
        <div
          id="CardTreatmentOrder-Div-TreatmentOrderScreen"
          style={{display:"flex"}}>
          
          <div
            id="CardTreatmentOrderUX-div-77"
            style={{fontWeight: "bold", fontSize: "1.25rem", padding: "20px 10px 10px" }}>
            {props.titleName || "Treatment"}
          </div>
          <div
            id="CardTreatmentOrderUX-div-78"
            style={{flex:"1"}}>
            
          </div>
          <div
            id="CardTreatmentOrderUX-div-88"
            style={{display: props.checkOutPerformDiv ? "grid" : "flex", margin: "1rem 1rem 0 0"}}>
            
            <div
              id="CardTreatmentOrderUX-div-89"
              style={{display: "flex", alignItems: "center", ...(props.hidePreOrder && {display: "none"})}}>
              
              <div
                id="CardTreatmentOrderUX-div-91"
                style={{marginRight: "10px"}}>
                
                <Checkbox
                  checked={props?.preOrderCheck || false}
                  id="CardTreatmentOrder-Checkbox-PreOrderCheck"
                  label={props.checkOutPerformDiv ? "คำสั่งนอกแผนก" : "สั่ง Treatment ล่วงหน้า"}
                  onChange={props.handleCheckPreOrder}
                  toggle={true}>
                </Checkbox>
              </div>
              <div
                id="CardTreatmentOrderUX-div-97">
                
                <DateTextBox
                  disabled={!props?.preOrderCheck }
                  id="CardTreatmentOrder-DateTextBox-PreOrderDate"
                  minDate={props?.minDate}
                  onChange={props?.onChangePreOrderDate("preOrderDate")}
                  style={{marginRight:"1rem", ...(props.checkOutPerformDiv && {display: "none"})}}
                  value={props?.preOrderDate}>
                </DateTextBox>
                <Dropdown
                  disabled={!props?.preOrderCheck }
                  id="CardTreatmentOrderUX-Dropdown-99"
                  onChange={props?.onChangePreOrderDate("preOrderDate")}
                  options={props.divisionOpdOptions || []}
                  selection={true}
                  style={{marginRight:"5px",marginTop:"5px", ...(!props.checkOutPerformDiv && {display: "none"})}}
                  value={props?.preOrderDate || ""}>
                </Dropdown>
              </div>
            </div>
            <div
              id="CardTreatmentOrderUX-div-90"
              style={{display: "flex", alignItems: "center", justifyContent: "flex-end", ...(props.checkOutPerformDiv && {marginTop: "1rem"}), ...(props.showPreOrder && {display: "none"})}}>
              
              <label
                id="CardTreatmentOrderUX-label-102"
                style={{marginRight: "10px", ...(!props.checkOutPerformDiv && {display: "none"})}}>
                {props.languageUX === "en" ? "Template" : "เทมเพลต"}
              </label>
              <Input
                id="CardTreatmentOrder-Input-TemplateOrder"
                placeholder={props.checkOutPerformDiv  ? "" : "template"}
                style={{marginRight:"5px"}}>
              </Input>
              <Button
                color="green"
                icon="search"
                id="CardTreatmentOrderUX-Button-101"
                onClick={props?.onSearch}>
              </Button>
            </div>
          </div>
        </div>
        <div
          id="CardTreatmentOrderUX-div-64"
          style={{padding: "10px"}}>
          {props?.ErrorMessage}
        </div>
        <div
          id="CardTreatmentOrderUX-div-4"
          style={{padding: "10px"}}>
          
          <div
            id="CardTreatmentOrderUX-div-2"
            style={{display: "flex", alignItems: "center"}}>
            
            <div
              id="CardTreatmentOrderUX-div-8"
              style={{marginLeft: "10px", marginRight: "5px", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "List of surgical procedures" : "รายการหัตถการ"}
            </div>
            <div
              id="CardTreatmentOrderUX-div-61"
              style={{position: "relative", width: "100%"}}>
              
              <div
                id="txt-searchTreatment"
                style={{width: "100%"}}>
                {props.searchTreatmentListBox}
              </div>
            </div>
            <Button
              color="blue"
              id="btn-searchTreatment"
              onClick={props.openModTreatmentItems}
              style={{marginLeft: "10px", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Search Treatment" : "ค้นหาหัตถการ"}
            </Button>
            <Button
              color="blue"
              onClick={props.onOpenOrderSet}
              style={{ minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Add Order set" : "เพิ่มจาก Order set"}
            </Button>
          </div>
          <div
            id="CardTreatmentOrderUX-div-3">
            
            <Table
              data={props.treatmentList}
              getTdProps={props.getTdProps}
              headers={!props.checkOutPerformDiv ? "รายการหัตถการ,จำนวน,รายละเอียดเบิก,ราคาต่อหน่วย,ราคารวม,เบิกได้,เบิกไม่ได้,สถานะ" : "รายการหัตถการ,จำนวน,รายละเอียดเบิก,ราคาต่อหน่วย,ราคารวม,เบิกได้,เบิกไม่ได้,Del"}
              id="tb-treatmentList"
              keys={!props.checkOutPerformDiv ? "product,quantity,claim,price_unit,price_total,price_claimable,price_non_claimable,status" : "product,quantity,claim,price_unit,price_total,price_claimable,price_non_claimable,del"}
              minRows="3"
              resizable={false}
              showPagination={false}
              style={{height: "200px", marginTop: "0.5rem"}}
              widths={"^200,auto,^200,auto,auto,auto,auto,auto"}>
            </Table>
          </div>
        </div>
        <div
          id="CardTreatmentOrderUX-div-16"
          style={{padding: "10px", position: "relative", display: props.hidePrincipalDiagnosis ? "none" : "" }}>
          
          <div
            id="CardTreatmentOrderUX-div-57"
            style={{fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Principal Procedure" : "ขั้นตอนหลัก"}
          </div>
          <div
            id="CardTreatmentOrderUX-div-17"
            style={{display: "flex", alignItems: "center",position:"relative"}}>
            
            <div
              id="CardTreatmentOrderUX-div-18"
              style={{marginLeft: "10px", marginRight: "5px", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Medical Term" : "ศัพท์ทางการแพทย์"}
            </div>
            <Input
              fluid={true}
              icon="search"
              id="txt-medicalterm"
              loading={props?.loadingmedTermPrincipal}
              name="medterm"
              onChange={props.onSearchTextChange("medTermPrincipal")}
              style={{width: "100%"}}
              value={props.medTermPrincipal}>
            </Input>
            <div
              id="CardTreatmentOrderUX-div-20"
              style={{marginLeft: "10px", marginRight: "5px", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "ICD9CM Term" : "คำศัพท์ ICD9CM"}
            </div>
            <Input
              fluid={true}
              icon="search"
              id="txt-icd9term"
              loading={props?.loadingICD9CMTermPrincipal}
              name="icdterm"
              onChange={props.onSearchTextChange("ICD9CMTermPrincipal")}
              style={{width: "100%"}}
              value={props.ICD9CMTermPrincipal}>
            </Input>
            <div
              id="CardTreatmentOrderUX-div-22"
              style={{marginLeft: "10px", marginRight: "5px", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "ICD9CM Code" : "รหัส ICD9CM"}
            </div>
            <Input
              fluid={true}
              icon="search"
              id="txt-icd9code"
              loading={props?.loadingICD9CMCodeprincipal}
              name="icdcode"
              onChange={props.onSearchTextChange("ICD9CMCodeprincipal")}
              style={{width: "100%"}}
              value={props.ICD9CMCodeprincipal}>
            </Input>
            <Button
              color="green"
              id="btn-addDiagnosis"
              onClick={props.onAddPrincipal}
              style={{marginLeft: "10px", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Add item" : "เพิ่มรายการ"}
            </Button>
          </div>
          <div
            id="CardTreatmentOrderUX-div-65"
            style={{display: props.showSearchResult ? "block" : "none", position: "absolute", zIndex: 100, width: "calc(100% - 20px)", height: "400px" }}>
            
            <Table
              data={props?.icd9Search}
              getTrProps={props?.icd9RowProps}
              headers="Medical Term,ICD9CM,ICD9CM"
              id="CardTreatmentOrderUX-Table-66"
              keys="medterm,icdterm,icdcode"
              minRows="4"
              showPagination={false}
              style={{height:"150px"}}>
            </Table>
          </div>
          <div
            id="CardTreatmentOrderUX-div-25">
            
            <Table
              data={props.diagnosisListPrincipal}
              headers="Medical Term, ICD9CM, ICD9CM"
              id="tb-diagListPrinciple"
              keys="icd9cm_med_term,icd9cm_term,icd9cm_code"
              minRows="3"
              showPagination={false}
              style={{height: "200px", marginTop: "0.5rem"}}>
            </Table>
          </div>
        </div>
        <div
          id="CardTreatmentOrderUX-div-27"
          style={{padding: "10px",  position: "relative", display : props.hideSecondaryDiagnosis ? "none" : ""}}>
          
          <div
            id="CardTreatmentOrderUX-div-58"
            style={{fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Secondary Procedure" : "ขั้นตอนรอง"}
          </div>
          <div
            id="CardTreatmentOrderUX-div-28"
            style={{display: "flex", alignItems: "center",position:"relative"}}>
            
            <div
              id="CardTreatmentOrderUX-div-29"
              style={{marginLeft: "10px", marginRight: "5px",minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Medical Term" : "ศัพท์ทางการแพทย์"}
            </div>
            <Input
              fluid={true}
              icon="search"
              id="CardTreatmentOrder-Input-SecondMedicalTerm"
              loading={props?.loadingMedTermSecondary}
              name="medterm"
              onChange={props.onSearchSecondaryChange("medTermSecondary")}
              style={{width: "100%"}}
              value={props?.medTermSecondary}>
            </Input>
            <div
              id="CardTreatmentOrderUX-div-31"
              style={{marginLeft: "10px", marginRight: "5px",minWidth: "max-content"}}>
              {props.languageUX === "en" ? "ICD9CM Term" : "คำศัพท์ ICD9CM"}
            </div>
            <Input
              fluid={true}
              icon="search"
              id="CardTreatmentOrder-Input-SecondIcd9Term"
              loading={props?.loadingICD9MTermSecondary}
              name="icdterm"
              onChange={props.onSearchSecondaryChange("ICD9MTermSecondary")}
              style={{width: "100%"}}
              value={props?.ICD9MTermSecondary}>
            </Input>
            <div
              id="CardTreatmentOrderUX-div-33"
              style={{marginLeft: "10px", marginRight: "5px",minWidth: "max-content"}}>
              {props.languageUX === "en" ? "ICD9CM Code" : "รหัส ICD9CM"}
            </div>
            <Input
              fluid={true}
              icon="search"
              id="CardTreatmentOrder-Input-SecondIcd9Code"
              loading={props?.loadingICD9MCodeSecondary}
              name="icdcode"
              onChange={props.onSearchSecondaryChange("ICD9MCodeSecondary")}
              style={{width: "100%"}}
              value={props.ICD9MCodeSecondary}>
            </Input>
            <Button
              color="green"
              id="CardTreatmentOrder-Button-AddSecondProcedure"
              onClick={props.onAddSecondary}
              style={{marginLeft: "10px",minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Add item" : "เพิ่มรายการ"}
            </Button>
          </div>
          <div
            id="CardTreatmentOrderUX-div-67"
            style={{display: props.showSearchResultSecondary ? "block" : "none", position: "absolute", zIndex: 100, width: "calc(100% - 20px)", height: "400px" }}>
            
            <Table
              data={props?.secondarySearch}
              getTrProps={props?.secondaryRowProps}
              headers="Medical Term,ICD9CM,ICD9CM"
              id="CardTreatmentOrderUX-Table-68"
              keys="medterm,icdterm,icdcode"
              minRows="4"
              showPagination={false}
              style={{height:"150px"}}>
            </Table>
          </div>
          <div
            id="CardTreatmentOrderUX-div-36">
            
            <Table
              data={props?.diagnosisListSecondary}
              getTrProps={props?.secondaryRowProps}
              headers="Medical Term,ICD9CM Term,ICD9CM Code"
              id="CardTreatmentOrderUX-Table-37"
              keys="icd9cm_med_term,icd9cm_term,icd9cm_code"
              minRows="3"
              showPagination={false}
              style={{height: "200px", marginTop: "0.5rem"}}>
            </Table>
          </div>
        </div>
        <div
          id="CardTreatmentOrderUX-div-39"
          style={{height: "350px", padding: "10px"}}>
          
          <div
            id="CardTreatmentOrderUX-div-38"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(13, 1fr)","gridTemplateColumns":"repeat(40, 1fr)"}}>
            <div
              id="CardTreatmentOrderUX-div-40"
              style={{ gridRow: "1/3", gridColumn: "1/7",  padding: "5px", display: "flex"}}>
              {props.languageUX === "en" ? "Operator" : "ผู้ทำหัตถการ"}
              <div
                id="CardTreatmentOrderUX-div-127"
                style={{color:"red"}}>
                *
              </div>
            </div>
            <div
              className="ui form"
              id="txt-responsible"
              style={{padding: "5px", gridRow: "1/3", gridColumn: "8/41",  }}>
              <Dropdown
                compact={true}
                error={props?.toBePerformMissing}
                fluid={ true}
                id="cb-responsible"
                onChange={props?.handleChangeValue("toBePerformer")}
                options={props?.options}
                search={true}
                selection={true}
                value={props?.toBePerformer}>
              </Dropdown>
            </div>
            <div
              id="CardTreatmentOrderUX-div-42"
              style={{ gridRow: "3/7", gridColumn: "1/7",  padding: "5px"}}>
              {props.languageUX === "en" ? "More details" : "รายละเอียดเพิ่มเติม"}
            </div>
            <div
              className="ui form"
              id="CardTreatmentOrderUX-div-43"
              style={{ padding: "5px",gridRow: "3/7", gridColumn: "8/41", }}>
              <TextArea
                id="CardTreatmentOrder-TextArea-OrderDetail"
                onChange={props?.handleChangeValue("orderDetail")}
                style={{width: "100%", height: "100%", border: "solid #cccccc 1px"}}
                value={props?.orderDetail}>
              </TextArea>
            </div>
            <div
              id="CardTreatmentOrderUX-div-44"
              style={{ gridRow: "7/11", gridColumn: "1/7",  padding: "5px"}}>
              {props.languageUX === "en" ? "equipment" : "อุปกรณ์"}
            </div>
            <div
              className="ui form"
              id="CardTreatmentOrderUX-div-45"
              style={{  padding: "5px", gridRow: "7/11", gridColumn: "8/41",  }}>
              {}
              <TextArea
                id="CardTreatmentOrder-TextArea-EquipmentDetail"
                onChange={props?.handleChangeValue("equipmentDetail")}
                style={{width: "100%", height: "100%", border: "solid #cccccc 1px"}}
                value={props?.equipmentDetail}>
              </TextArea>
            </div>
            <div
              className="ui form --override-disabled --grey"
              id="CardTreatmentOrderUX-div-46"
              style={{ gridRow: "12/13", gridColumn: "1/41"  }}>
              
              <FormGroup
                id="CardTreatmentOrderUX-FormGroup-107"
                inline={true}
                style={{margin: 0}}>
                <FormField
                  id="CardTreatmentOrderUX-FormField-108"
                  inline={true}
                  style={{flex: 1}}>
                </FormField>
                <FormField
                  id="CardTreatmentOrderUX-FormField-109"
                  inline={true}>
                  <div
                    id="CardTreatmentOrderUX-div-120">
                    {props.languageUX === "en" ? "price" : "ราคา"}
                  </div>
                </FormField>
                <FormField
                  id="CardTreatmentOrderUX-FormField-110"
                  inline={true}
                  width={3}>
                  <Input
                    disabled={true}
                    fluid={true}
                    id="CardTreatmentOrderUX-Input-121"
                    style={{width: "100%"}}
                    value={Number(props?.treatmentOrder?.price_total||"0").toLocaleString("en-US", {minimumFractionDigits: 2,maximumFractionDigits: 2,})}>
                  </Input>
                </FormField>
                <FormField
                  id="CardTreatmentOrderUX-FormField-111"
                  inline={true}>
                  <div
                    id="CardTreatmentOrderUX-div-119"
                    style={{minWidth:"max-content"}}>
                    {props.languageUX === "en" ? "Claimable" : "เบิกได้"}
                  </div>
                </FormField>
                <FormField
                  id="CardTreatmentOrderUX-FormField-112"
                  inline={true}
                  width={3}>
                  <Input
                    disabled={true}
                    fluid={true}
                    id="CardTreatmentOrderUX-Input-122"
                    style={{width: "100%"}}
                    value={Number(props?.treatmentOrder?.price_claimable||"0").toLocaleString("en-US", {minimumFractionDigits: 2,maximumFractionDigits: 2,})}>
                  </Input>
                </FormField>
                <FormField
                  id="CardTreatmentOrderUX-FormField-113"
                  inline={true}>
                  <div
                    id="CardTreatmentOrderUX-div-118"
                    style={{minWidth:"max-content"}}>
                    {props.languageUX === "en" ? "Non Claimable" : "เบิกไม่ได้"}
                  </div>
                </FormField>
                <FormField
                  id="CardTreatmentOrderUX-FormField-114"
                  inline={true}
                  width={3}>
                  <Input
                    disabled={true}
                    fluid={true}
                    id="CardTreatmentOrderUX-Input-123"
                    style={{width: "100%"}}
                    value={Number(props?.treatmentOrder?.price_non_claimable ||"").toLocaleString("en-US", {minimumFractionDigits: 2,maximumFractionDigits: 2,})}>
                  </Input>
                </FormField>
              </FormGroup>
            </div>
            <div
              id="CardTreatmentOrderUX-div-52"
              style={{ gridRow: "14/16", gridColumn: "1/41", display: "flow-root", justifyContent: 'flex-end', }}>
              <div
                id="CardTreatmentOrderUX-div-128"
                style={{ float: "left" }}>
                {props.orderByBox}
              </div>
              <div
                id="CardTreatmentOrderUX-div-129"
                style={{ float: "right", display: "flex" }}>
                
                <div
                  id="CardTreatmentOrderUX-div-125"
                  style={{ ...(props.hideSaveButton && { display: "none" }) }}>
                  {props.buttonSaveOrder}
                </div>
                <div
                  id="CardTreatmentOrderUX-div-126"
                  style={{ ...(props.hideSaveButton && { display: "none" }) }}>
                  {props.buttonConfirmOrder}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardTreatmentOrderUX-div-103"
          style={{display:props.checkOutPerformDiv ?  "none": "",padding: "0px 10px 20px 10px"}}>
          
          <Table
            data={props.OrderTreatments}
            getTrProps={props.orderRowProps}
            headers="Treatment Detail,Care provider,Del,Edit,Status"
            id="tb-tratementOrderStatus"
            keys="detail,careprovider,delete,edit,status"
            minRows="5"
            showPagination={false}
            style={{height:"250px"}}
            widths="auto,230px,80px,80px,130px">
          </Table>
        </div>
      </div>
    )
}


export default CardTreatmentOrderUX

export const screenPropsDefault = {"showTreatmentList":true}

/* Date Time : Thu Oct 09 2025 13:04:28 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-3"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 7,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.treatmentList"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTheadThProps": {
          "type": "value",
          "value": ""
        },
        "headers": {
          "type": "code",
          "value": "!props.checkOutPerformDiv ? \"รายการหัตถการ,จำนวน,รายละเอียดเบิก,ราคาต่อหน่วย,ราคารวม,เบิกได้,เบิกไม่ได้,สถานะ\" : \"รายการหัตถการ,จำนวน,รายละเอียดเบิก,ราคาต่อหน่วย,ราคารวม,เบิกได้,เบิกไม่ได้,Del\""
        },
        "id": {
          "type": "value",
          "value": "tb-treatmentList"
        },
        "keys": {
          "type": "code",
          "value": "!props.checkOutPerformDiv ? \"product,quantity,claim,price_unit,price_total,price_claimable,price_non_claimable,status\" : \"product,quantity,claim,price_unit,price_total,price_claimable,price_non_claimable,del\""
        },
        "minRows": {
          "type": "value",
          "value": "3"
        },
        "pageSize": {
          "type": "code",
          "value": ""
        },
        "resizable": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\", marginTop: \"0.5rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "\"^200,auto,^200,auto,auto,auto,auto,auto\""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการหัตถการ",
          "valueEN": "List of surgical procedures"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาหัตถการ",
          "valueEN": "Search Treatment"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "btn-searchTreatment"
        },
        "onClick": {
          "type": "code",
          "value": "props.openModTreatmentItems"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", position: \"relative\", display: props.hidePrincipalDiagnosis ? \"none\" : \"\" }"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",position:\"relative\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "ศัพท์ทางการแพทย์",
          "valueEN": "Medical Term"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Input",
      "parent": 17,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "txt-medicalterm"
        },
        "loading": {
          "type": "code",
          "value": "props?.loadingmedTermPrincipal"
        },
        "name": {
          "type": "value",
          "value": "medterm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchTextChange(\"medTermPrincipal\")"
        },
        "placeholder": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.medTermPrincipal"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "คำศัพท์ ICD9CM",
          "valueEN": "ICD9CM Term"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Input",
      "parent": 17,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "txt-icd9term"
        },
        "loading": {
          "type": "code",
          "value": "props?.loadingICD9CMTermPrincipal"
        },
        "name": {
          "type": "value",
          "value": "icdterm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchTextChange(\"ICD9CMTermPrincipal\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ICD9CMTermPrincipal"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส ICD9CM",
          "valueEN": "ICD9CM Code"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรายการ",
          "valueEN": "Add item"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "btn-addDiagnosis"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-25"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 26,
      "name": "Table",
      "parent": 25,
      "props": {
        "data": {
          "type": "code",
          "value": "props.diagnosisListPrincipal"
        },
        "headers": {
          "type": "value",
          "value": "Medical Term, ICD9CM, ICD9CM"
        },
        "id": {
          "type": "value",
          "value": "tb-diagListPrinciple"
        },
        "keys": {
          "type": "value",
          "value": "icd9cm_med_term,icd9cm_term,icd9cm_code"
        },
        "minRows": {
          "type": "value",
          "value": "3"
        },
        "pageSize": {
          "type": "code",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\", marginTop: \"0.5rem\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\",  position: \"relative\", display : props.hideSecondaryDiagnosis ? \"none\" : \"\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",position:\"relative\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "ศัพท์ทางการแพทย์",
          "valueEN": "Medical Term"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\",minWidth: \"max-content\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Input",
      "parent": 28,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Input-SecondMedicalTerm"
        },
        "loading": {
          "type": "code",
          "value": "props?.loadingMedTermSecondary"
        },
        "name": {
          "type": "value",
          "value": "medterm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchSecondaryChange(\"medTermSecondary\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.medTermSecondary"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "คำศัพท์ ICD9CM",
          "valueEN": "ICD9CM Term"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\",minWidth: \"max-content\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Input",
      "parent": 28,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Input-SecondIcd9Term"
        },
        "loading": {
          "type": "code",
          "value": "props?.loadingICD9MTermSecondary"
        },
        "name": {
          "type": "value",
          "value": "icdterm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchSecondaryChange(\"ICD9MTermSecondary\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.ICD9MTermSecondary"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส ICD9CM",
          "valueEN": "ICD9CM Code"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", marginRight: \"5px\",minWidth: \"max-content\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรายการ",
          "valueEN": "Add item"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Button-AddSecondProcedure"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddSecondary"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\",minWidth: \"max-content\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-36"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 37,
      "name": "Table",
      "parent": 36,
      "props": {
        "data": {
          "type": "code",
          "value": "props?.diagnosisListSecondary"
        },
        "getTrProps": {
          "type": "code",
          "value": "props?.secondaryRowProps"
        },
        "headers": {
          "type": "value",
          "value": "Medical Term,ICD9CM Term,ICD9CM Code"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Table-37"
        },
        "keys": {
          "type": "value",
          "value": "icd9cm_med_term,icd9cm_term,icd9cm_code"
        },
        "minRows": {
          "type": "value",
          "value": "3"
        },
        "pageSize": {
          "type": "code",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\", marginTop: \"0.5rem\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "label": "divgrid",
      "name": "div",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(13, 1fr)\",\"gridTemplateColumns\":\"repeat(40, 1fr)\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{height: \"350px\", padding: \"10px\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ทำหัตถการ",
          "valueEN": "Operator"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/3\", gridColumn: \"1/7\",  padding: \"5px\", display: \"flex\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 38,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "txt-responsible"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\", gridRow: \"1/3\", gridColumn: \"8/41\",  }"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดเพิ่มเติม",
          "valueEN": "More details"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/7\", gridColumn: \"1/7\",  padding: \"5px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 38,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\",gridRow: \"3/7\", gridColumn: \"8/41\", }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "อุปกรณ์",
          "valueEN": "equipment"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/11\", gridColumn: \"1/7\",  padding: \"5px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{  padding: \"5px\", gridRow: \"7/11\", gridColumn: \"8/41\",  }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/13\", gridColumn: \"1/41\"  }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"14/16\", gridColumn: \"1/41\", display: \"flow-root\", justifyContent: 'flex-end', }"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Dropdown",
      "parent": 41,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "error": {
          "type": "code",
          "value": "props?.toBePerformMissing"
        },
        "fluid": {
          "type": "code",
          "value": " true"
        },
        "id": {
          "type": "value",
          "value": "cb-responsible"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeValue(\"toBePerformer\")"
        },
        "options": {
          "type": "code",
          "value": "props?.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props?.toBePerformer"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "TextArea",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-TextArea-OrderDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeValue(\"orderDetail\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", border: \"solid #cccccc 1px\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.orderDetail"
        }
      },
      "seq": 54,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "TextArea",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-TextArea-EquipmentDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeValue(\"equipmentDetail\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", border: \"solid #cccccc 1px\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.equipmentDetail"
        }
      },
      "seq": 55,
      "void": true
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "ขั้นตอนหลัก",
          "valueEN": "Principal Procedure"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "ขั้นตอนรอง",
          "valueEN": "Secondary Procedure"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Input",
      "parent": 17,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "txt-icd9code"
        },
        "loading": {
          "type": "code",
          "value": "props?.loadingICD9CMCodeprincipal"
        },
        "name": {
          "type": "value",
          "value": "icdcode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchTextChange(\"ICD9CMCodeprincipal\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.ICD9CMCodeprincipal"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Input",
      "parent": 28,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Input-SecondIcd9Code"
        },
        "loading": {
          "type": "code",
          "value": "props?.loadingICD9MCodeSecondary"
        },
        "name": {
          "type": "value",
          "value": "icdcode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchSecondaryChange(\"ICD9MCodeSecondary\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ICD9MCodeSecondary"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", width: \"100%\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchTreatmentListBox"
        },
        "id": {
          "type": "value",
          "value": "txt-searchTreatment"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showSearchResult ? \"block\" : \"none\", position: \"absolute\", zIndex: 100, width: \"calc(100% - 20px)\", height: \"400px\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 66,
      "name": "Table",
      "parent": 65,
      "props": {
        "data": {
          "type": "code",
          "value": "props?.icd9Search"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props?.icd9RowProps"
        },
        "headers": {
          "type": "value",
          "value": "Medical Term,ICD9CM,ICD9CM"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Table-66"
        },
        "keys": {
          "type": "value",
          "value": "medterm,icdterm,icdcode"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"150px\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showSearchResultSecondary ? \"block\" : \"none\", position: \"absolute\", zIndex: 100, width: \"calc(100% - 20px)\", height: \"400px\" }"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 68,
      "name": "Table",
      "parent": 67,
      "props": {
        "data": {
          "type": "code",
          "value": "props?.secondarySearch"
        },
        "getTrProps": {
          "type": "code",
          "value": "props?.secondaryRowProps"
        },
        "headers": {
          "type": "value",
          "value": "Medical Term,ICD9CM,ICD9CM"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Table-68"
        },
        "keys": {
          "type": "value",
          "value": "medterm,icdterm,icdcode"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"150px\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Div-TreatmentOrderScreen"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleName || \"Treatment\""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.25rem\", padding: \"20px 10px 10px\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{display: props.checkOutPerformDiv ? \"grid\" : \"flex\", margin: \"1rem 1rem 0 0\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", ...(props.hidePreOrder && {display: \"none\"})}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\", ...(props.checkOutPerformDiv && {marginTop: \"1rem\"}), ...(props.showPreOrder && {display: \"none\"})}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Checkbox",
      "parent": 91,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.preOrderCheck || false"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Checkbox-PreOrderCheck"
        },
        "label": {
          "type": "code",
          "value": "props.checkOutPerformDiv ? \"คำสั่งนอกแผนก\" : \"สั่ง Treatment ล่วงหน้า\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckPreOrder"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 98,
      "name": "DateTextBox",
      "parent": 97,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props?.preOrderCheck "
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-DateTextBox-PreOrderDate"
        },
        "minDate": {
          "type": "code",
          "value": "props?.minDate"
        },
        "onChange": {
          "type": "code",
          "value": "props?.onChangePreOrderDate(\"preOrderDate\")"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"1rem\", ...(props.checkOutPerformDiv && {display: \"none\"})}"
        },
        "value": {
          "type": "code",
          "value": "props?.preOrderDate"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Dropdown",
      "parent": 97,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props?.preOrderCheck "
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Dropdown-99"
        },
        "onChange": {
          "type": "code",
          "value": "props?.onChangePreOrderDate(\"preOrderDate\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOpdOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\",marginTop:\"5px\", ...(!props.checkOutPerformDiv && {display: \"none\"})}"
        },
        "value": {
          "type": "code",
          "value": "props?.preOrderDate || \"\""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Input",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrder-Input-TemplateOrder"
        },
        "placeholder": {
          "type": "code",
          "value": "props.checkOutPerformDiv  ? \"\" : \"template\""
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Button",
      "parent": 90,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Button-101"
        },
        "onClick": {
          "type": "code",
          "value": "props?.onSearch"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": "เทมเพลต",
          "valueEN": "Template"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-label-102"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", ...(!props.checkOutPerformDiv && {display: \"none\"})}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{display:props.checkOutPerformDiv ?  \"none\": \"\",padding: \"0px 10px 20px 10px\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 104,
      "name": "Table",
      "parent": 103,
      "props": {
        "data": {
          "type": "code",
          "value": "props.OrderTreatments"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.orderRowProps"
        },
        "headers": {
          "type": "value",
          "value": "Treatment Detail,Care provider,Del,Edit,Status"
        },
        "id": {
          "type": "value",
          "value": "tb-tratementOrderStatus"
        },
        "keys": {
          "type": "value",
          "value": "detail,careprovider,delete,edit,status"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"250px\"}"
        },
        "widths": {
          "type": "value",
          "value": "auto,230px,80px,80px,130px"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormGroup",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormGroup-107"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Non Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกได้",
          "valueEN": "Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 109,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคา",
          "valueEN": "price"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Input",
      "parent": 110,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Input-121"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "Number(props?.treatmentOrder?.price_total||\"0\").toLocaleString(\"en-US\", {minimumFractionDigits: 2,maximumFractionDigits: 2,})"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "Input",
      "parent": 112,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Input-122"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "Number(props?.treatmentOrder?.price_claimable||\"0\").toLocaleString(\"en-US\", {minimumFractionDigits: 2,maximumFractionDigits: 2,})"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Input",
      "parent": 114,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-Input-123"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "Number(props?.treatmentOrder?.price_non_claimable ||\"\").toLocaleString(\"en-US\", {minimumFractionDigits: 2,maximumFractionDigits: 2,})"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveOrder"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.hideSaveButton && { display: \"none\" }) }"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirmOrder"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.hideSaveButton && { display: \"none\" }) }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderByBox"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"left\" }"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentOrderUX-div-129"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\", display: \"flex\" }"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มจาก Order set",
          "valueEN": "Add Order set"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenOrderSet"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\"}"
        }
      },
      "seq": 130,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardTreatmentOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "showTreatmentList": true
  },
  "width": 80
}

*********************************************************************************** */
